module.exports = __webpack_public_path__ + "static/media/development-sistema-viario.eafc9e2c.png";